import React from 'react';
// TODO: (A.H.) - Need to refactor
// import { useHamburgerMenu } from './hook';
// import { HamburgerMenu } from '@yme/atoms/hamburger-menu';
import { useSelector } from 'react-redux';
import { CloseHamburgerMenu, HamburgerMenu as HamburgerMenuIcon } from '@yme/assets/icons';
import { getRTL } from '@yme/selectors/common';
import { HamburgerButtonStyled, HamburgerMenuStyled } from './styled';
export function HamburgerButton({ isMenuShowed, onClickMenu, }) {
    const isRightToLeft = useSelector(getRTL);
    // TODO: (A.H.) - Need to refactor
    // const refMainMenu = useRef<HTMLUListElement>(null);
    // const { isVisibleMenu, onClickHamburgerMenu } = useHamburgerMenu({ ref: refMainMenu });
    const currentIconType = isMenuShowed ? CloseHamburgerMenu : HamburgerMenuIcon;
    return (React.createElement(HamburgerButtonStyled, null,
        React.createElement(HamburgerMenuStyled, { isRightToLeft: isRightToLeft, type: currentIconType, onClick: onClickMenu })));
}
HamburgerButton.displayName = 'HamburgerButton';
